import { OpenAPISpecProcessingErrorCode } from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

/**
 * Get the error message for a given OpenAPI spec processing error code.
 */
export function getOpenAPIProcessingErrorMessage(errorCode: OpenAPISpecProcessingErrorCode) {
    switch (errorCode) {
        case OpenAPISpecProcessingErrorCode.FETCH_TIMEOUT: {
            return 'Failed to fetch OpenAPI spec, request timed out. Please check the URL and try again.';
        }
        case OpenAPISpecProcessingErrorCode.FETCH_ERROR: {
            return 'Failed to fetch OpenAPI spec. Please check the URL and try again.';
        }
        case OpenAPISpecProcessingErrorCode.PARSE_ERROR: {
            return 'Failed to parse OpenAPI spec. Please check that it is a valid OpenAPI specification.';
        }
        default:
            assertNever(errorCode);
    }
}
